// Периодът на „Справка отчети за дата" — отчетът от фискалната памет.
// Пресетите, границите им и праговете живеят тук, за да ги четат и полетата
// (FmReportFields — подсказката с датите), и изпращането (OperationsModal —
// заявката) от едно място и датите да не се разминават.
import dayjs, { type Dayjs } from "dayjs";
import type { FmReportDetail } from "../../../../../api/operations";

/** Бързите пресети — с фиксирани граници, без календари. */
export type FmQuickPreset = "lastMonth" | "thisMonth";
export type FmReportPreset = FmQuickPreset | "period";

// Месечният отчет от фискалната памет се пуска до 7-о число на следващия
// месец и на практика излиза на 1-во/2-ро: до този ден бързият избор по
// подразбиране е „Предходен месец", след него — „Този месец".
export const MONTHLY_REPORT_DEADLINE_DAY = 7;

// Подробният отчет печата по блок за всеки Z — над едно тримесечие (92 дни)
// това са метри хартия и минути печат. НЕ е забрана: понякога точно такъв
// отчет трябва (проверка, счетоводител) — над прага операторът потвърждава
// изрично. Съкратеният само сумира ФП (секунди) и няма праг.
export const FM_REPORT_LONG_PERIOD_DAYS = 92;

export interface FmPeriod {
  start: Dayjs;
  end: Dayjs;
  /** Календарни дни в периода, двата края включително. */
  spanDays: number;
}

export const buildFmPeriod = (start: Dayjs, end: Dayjs): FmPeriod => ({
  start,
  end,
  spanDays: end.startOf("day").diff(start.startOf("day"), "day") + 1,
});

export const defaultFmPreset = (now: Dayjs = dayjs()): FmQuickPreset =>
  now.date() <= MONTHLY_REPORT_DEADLINE_DAY ? "lastMonth" : "thisMonth";

/** Границите на бърз пресет: целият предходен месец или текущият до днес. */
export const fmPresetRange = (
  preset: FmQuickPreset,
  now: Dayjs = dayjs(),
): FmPeriod => {
  if (preset === "lastMonth") {
    const lastMonth = now.subtract(1, "month");
    return buildFmPeriod(lastMonth.startOf("month"), lastMonth.endOf("month"));
  }
  return buildFmPeriod(now.startOf("month"), now.endOf("day"));
};

/** Дълъг подробен отчет — иска изрично потвърждение, не се спира. */
export const isLongFmReport = (
  detail: FmReportDetail,
  period: FmPeriod,
): boolean => detail === "full" && period.spanDays > FM_REPORT_LONG_PERIOD_DAYS;
